const COLORS = {
  white: '#FFFFFF',
  red: '#E20030',
  orange: '#FF8819',
  orangeChart: '#FF9900',
  purple: '#EE72E9',
  blue: '#007FDC',
  blueChart: '#0D5BB6',
  green: '#00BF35',
  greenChart: '#00BF63',
  aqua: '#23ECE0',
  gray: '#888888',
  backgroundSecond: '#f8f9fa',

  content: '#2C2D2F',
  auxiliarContent: '#6D757B',
  lightLine: '#d4dde0',

  nullContry: '#E7ECEF',

  stackedChart: ['#E41A45', '#FF8787', '#FFC9AA', '#0059C2', '#009AF0', '#6CE7F8'],
  blueGradiendOne: '#1572DE',
  blueGradiendTwo: '#0D5BB6',

  redGradiend: '#EE476B',
  barChart: '#E5EDF0',
};

export const chartGradientColors: Highcharts.GradientColorObject[] = [
  {
    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    stops: [
      [0, COLORS.blueGradiendOne],
      [1, COLORS.blueGradiendTwo],
    ],
  },
  {
    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    stops: [
      [0, COLORS.redGradiend],
      [1, COLORS.red],
    ],
  },
];

export default COLORS;
